import { createVNode } from "inferno";
export default function AnnotationHeader(props, context) {
  var _translate = context.injector.get('translate');

  return createVNode(1, "th", "annotation header", _translate('Annotation'), 0, {
    "rowspan": "3"
  });
}
//# sourceMappingURL=AnnotationHeader.js.map